import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-[#111827] text-white/60 py-8" data-id="element-51">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-4" data-id="element-52">
          <div className="flex items-center gap-6" data-id="element-53">
            <button onClick={() => setActiveModal('privacy')} className="text-sm hover:text-gold transition-colors underline underline-offset-2" data-id="element-54">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-55">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm hover:text-gold transition-colors underline underline-offset-2" data-id="element-56">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-white/40" data-id="element-57">
            © {new Date().getFullYear()} 30 Días con Dios. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-58">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-59">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white text-dark rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-60">
              <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-61">
                <h2 className="text-xl font-serif font-bold text-navy" data-id="element-62">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-63">
                  <X className="w-5 h-5 text-gray-500" data-id="element-64" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] prose prose-sm max-w-none" data-id="element-65">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-66" /> : <TermsContent data-id="element-67" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <div className="space-y-4 text-dark/80 leading-relaxed" data-id="element-68">
      <p className="text-sm text-muted" data-id="element-69">Última actualización: Abril 2026</p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-70">
        1. Información que recopilamos
      </h3>
      <p data-id="element-71">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos información de tarjetas de
        crédito directamente; los pagos son procesados por plataformas de pago
        seguras de terceros.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-72">
        2. Uso de la información
      </h3>
      <p data-id="element-73">Tu información personal se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-74">
        <li data-id="element-75">Procesar y entregar tu compra</li>
        <li data-id="element-76">Enviar el enlace de descarga del producto</li>
        <li data-id="element-77">Comunicarnos contigo respecto a tu pedido o garantía</li>
        <li data-id="element-78">
          Enviar actualizaciones del producto (solo si das tu consentimiento)
        </li>
      </ul>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-79">
        3. Protección de datos
      </h3>
      <p data-id="element-80">
        Implementamos medidas de seguridad razonables para proteger tu
        información personal contra acceso no autorizado, alteración o
        destrucción. Sin embargo, ningún método de transmisión por Internet es
        100% seguro.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-81">
        4. Compartir información
      </h3>
      <p data-id="element-82">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de pago necesarios para
        completar tu transacción.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-83">5. Cookies</h3>
      <p data-id="element-84">
        Podemos utilizar cookies para mejorar tu experiencia de navegación y
        analizar el tráfico del sitio. Puedes desactivar las cookies en la
        configuración de tu navegador.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-85">
        6. Tus derechos
      </h3>
      <p data-id="element-86">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, contáctanos a través
        de los canales indicados en tu confirmación de compra.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-87">
        7. Cambios a esta política
      </h3>
      <p data-id="element-88">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Los cambios serán publicados en esta página con la fecha de
        actualización correspondiente.
      </p>
    </div>;
}
function TermsContent() {
  return <div className="space-y-4 text-dark/80 leading-relaxed" data-id="element-89">
      <p className="text-sm text-muted" data-id="element-90">Última actualización: Abril 2026</p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-91">
        1. Producto digital
      </h3>
      <p data-id="element-92">
        "30 Días con Dios — Orden, Provisión y Abundancia" es un producto
        digital que incluye un ebook en PDF. El acceso se entrega de forma
        inmediata tras la confirmación del pago.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-93">
        2. Licencia de uso
      </h3>
      <p data-id="element-94">
        Al adquirir este producto, recibes una licencia personal e
        intransferible. Queda prohibida la reproducción, distribución, reventa o
        compartición del material con terceros sin autorización expresa.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-95">
        3. Garantía de devolución
      </h3>
      <p data-id="element-96">
        Ofrecemos una garantía de satisfacción de 7 días calendario a partir de
        la fecha de compra. Si dentro de ese plazo consideras que el producto no
        cumple tus expectativas, puedes solicitar un reembolso completo
        siguiendo las instrucciones proporcionadas en el producto.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-97">
        4. Descargo de responsabilidad
      </h3>
      <p data-id="element-98">
        Este material tiene propósito espiritual y educativo. No constituye ni
        sustituye asesoría médica, psicológica, financiera, legal ni profesional
        de ningún tipo. Los resultados pueden variar según la dedicación y
        circunstancias individuales de cada persona.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-99">
        5. Propiedad intelectual
      </h3>
      <p data-id="element-100">
        Todo el contenido del producto — textos, audios, diseños y materiales
        complementarios — está protegido por derechos de autor. Cualquier uso no
        autorizado será perseguido conforme a la legislación aplicable.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-101">
        6. Precio y disponibilidad
      </h3>
      <p data-id="element-102">
        El precio actual es un precio de lanzamiento y puede cambiar sin previo
        aviso. La compra al precio vigente garantiza acceso permanente al
        material adquirido.
      </p>

      <h3 className="text-lg font-serif font-bold text-navy" data-id="element-103">
        7. Modificaciones
      </h3>
      <p data-id="element-104">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor desde su publicación en
        esta página.
      </p>
    </div>;
}